<template lang="pug">
  v-container#actions(fluid)
    h1.form-title2.accent-text.pb-5 Información sobre acciones realizadas
    .d-flex
      .form-title.main-text.light Denuncias
      v-btn.ml-3(outlined fab color="#4a4a4a" @click="addPoliceReport()")
        v-icon add

    v-row.py-1(v-for="(policeReport, i) in policeReports" :key="i + 'report'")
      PoliceReport(:index="i" :report="policeReport")

    v-row.py-1
      .d-flex
        .form-title.main-text.light Otras acciones
        v-btn.ml-3(outlined fab color="#4a4a4a" @click="addOtherActions()")
          v-icon add
    v-row.py-1(v-for="(action, j) in actions" :key="j + 'action'")
      OtherActions(:index="j" :action="action")

</template>

<script>
import PoliceReport from "./Actions/PoliceReport.vue";
import OtherActions from "./Actions/OtherActions.vue";
import * as _ from "lodash";

export default {
  name: "Actions",
  components: {
    PoliceReport,
    OtherActions
  },
  computed: {
    policeReports(){
      return this.$store.state.record.narrative.policeReports;
    },
    actions(){
      return this.$store.state.record.narrative.actions;
    }
  },
  methods: {
    addPoliceReport() {
      this.$store.state.record.narrative.policeReports.push(_.cloneDeep(this.$store.state.policeReport));
    },
    addOtherActions() {
      this.$store.state.record.narrative.actions.push(_.cloneDeep(this.$store.state.action));
    }
  }
};
</script>

<style scoped lang="scss">
.v-btn--fab.v-size--default {
  height: 45px;
  width: 45px;
}
</style>
